import { isInteger, isArray, isString, isObject, isEmpty, isBoolean, isDate, trim } from 'lodash'

import { validatorCreator } from 'utils/helpers/validators/validatorCreator'

export const VALIDATION_ERRORS_ENUM = {
  CANNOT_BE_EMPTY: 'This field is required.',
}

const requiredFieldValidators = [
  {
    name: 'Field cannot be empty',
    isValid: ({ value, isRequired }) =>
      // NOTE: handle such value types as: numbers, strings, arrays, objects, booleans, dates
      !isRequired ||
      isDate(value) ||
      isInteger(value) ||
      isBoolean(value) ||
      (isString(value) && !isEmpty(trim(value))) ||
      (isObject(value) && !isEmpty(value)) ||
      (isArray(value) && !isEmpty(value)),
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
]

export const validateRequiredField = validatorCreator(requiredFieldValidators)
